<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default{
  name: 'App'
}
</script>

<style lang="">
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: RGBA(25, 48, 133, 1);
}

* {
  font-family: PingFangSC-Regular;
  color: #fff;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/App.vue